import { render, staticRenderFns } from "./TransposonSearch.vue?vue&type=template&id=b6ab6984&scoped=true"
import script from "./TransposonSearch.vue?vue&type=script&lang=js"
export * from "./TransposonSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ab6984",
  null
  
)

export default component.exports